<script>
    import {onDestroy, getContext} from 'svelte';
    import {uuid} from "@manaakiwhenua/frag-svelte/src/uuid";
    import {removeReadyStoreKey, updateReadyStore} from "@manaakiwhenua/frag-svelte/src/print-util/readyStore";

    const readyStore = getContext('readyStore');
    const instanceId = uuid();

    updateReadyStore(readyStore, instanceId, false);

    onDestroy(() => {
        removeReadyStoreKey(readyStore, instanceId);
    });
</script>
<style>
    span {
        display: none;
    }
</style>
<span></span>